import { SHOW_MODAL, HIDE_MODAL, SUBMIT_START, SUBMIT_ERROR,
    SUBMIT_STOP } from '../actions/userModalActions';

const INIT_STATE = {
    visible: false,
    submitting: false,
    type: null,
    data: null,
};

const userModalReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case SHOW_MODAL: {
            return { ...state, visible: true, submitting: false, type: action.payload.type, data: action.payload.data };
        }
        case HIDE_MODAL: {
            return { ...state, visible: false, submitting: false, type: null, data: null };
        }
        case SUBMIT_START: {
            return { ...state, submitting: true };
        }
        case SUBMIT_ERROR: {
            return { ...state, submitting: false };
        }
        case SUBMIT_STOP: {
            return { ...state, submitting: false };
        }
        default:
            return state;
    }
}

export default userModalReducer;
